var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap",
      staticStyle: { width: "1300px", height: "600px", overflow: "hidden" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(" close ")]
      ),
      _c("h1", { staticClass: "page_title" }, [
        _vm._v(_vm._s(_vm.$t("msg.VOSD100_M5.011"))),
      ]),
      _c(
        "div",
        {
          staticClass: "popup_cont",
          staticStyle: { "overflow-y": "auto", "max-height": "500px" },
        },
        [
          _c("ScheduleLeg", {
            attrs: { "parent-info": _vm.parentInfo },
            on: { close: _vm.closePopup, ScheduleLegPop: _vm.throwBkgParams },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }